import { mergeDeepRight } from 'ramda'
import validate from './validations/nl-NL.json'
import content from './contents/nl-NL.js'
import country from './country/nl-NL.json'

export default mergeDeepRight(content, { validate, country })
